if (!customElements.get('custom-tabs')) {
  customElements.define(
    'custom-tabs',
    class CustomTabs extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          activeButton: 'custom-tabs__nav-item--active',
          activeContent: 'custom-tabs__content-item--active',
        };

        this.elements = {
          buttons: this.querySelectorAll('.custom-tabs__nav-item'),
          contents: this.querySelectorAll('.custom-tabs__content-item'),
        };
      }

      connectedCallback() {
        this.elements.buttons.forEach((button) => {
          button.addEventListener('click', this.onClick.bind(this));
        });

        // On Left and Right Arrow Key press
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            this.onArrowPress(event);
          }
        });
      }

      onClick(event) {
        const button = event.target;
        const target = button.dataset.target;
        this.elements.buttons.forEach((button) => {
          button.classList.remove(this.classes.activeButton);
          button.setAttribute('aria-selected', 'false');
        });
        this.elements.contents.forEach((content) => {
          content.classList.remove(this.classes.activeContent);
          content.setAttribute('aria-hidden', 'true');
        });
        button.classList.add(this.classes.activeButton);
        button.setAttribute('aria-selected', 'true');

        const $target = this.querySelector(`[data-content="${target}"]`);
        $target.classList.add(this.classes.activeContent);
        $target.setAttribute('aria-hidden', 'false');
      }

      onArrowPress(event) {
        // Bail early if the focus is not on the tabs
        if (!Array.from(this.elements.buttons).some((button) => button === document.activeElement)) return;

        const currentIndex = Array.from(this.elements.buttons).findIndex((button) =>
          button.classList.contains(this.classes.activeButton),
        );
        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') {
          nextIndex = currentIndex === 0 ? this.elements.buttons.length - 1 : currentIndex - 1;
        } else if (event.key === 'ArrowRight') {
          nextIndex = currentIndex === this.elements.buttons.length - 1 ? 0 : currentIndex + 1;
        }
        this.elements.buttons[nextIndex].click();
        this.elements.buttons[nextIndex].focus();
      }
    },
  );
}
